import React, { useEffect, useState } from 'react';
// import { BASE_URL, ENV_SITE_DEV } from '../../constants';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import CookieConcentPopup from '../components/CookieConcentPopup';
import { BASE_URL } from '../../constants';


const defaultProps = {
    children: [],
    bypassAuthCheck: false,
    secure: false
}

const FrontendLayout = ({ children = defaultProps.children, bypassAuthCheck = defaultProps.bypassAuthCheck, secure = defaultProps.secure }) => {

    const navigate = useNavigate();
    const user = useSelector(s => s.auth.data);
    const location = useLocation();
    const [bgColor, setBgColor] = useState('bg-header');

    useEffect(() => {
        document.getElementById('root').classList.add('w-100');
        document.getElementById('root').classList.remove('d-flex');
        document.getElementById('root').classList.remove('flex-grow-1');
        if (user.id && !location.pathname.startsWith('/portal')) {
            navigate({
                pathname: '/portal'
            });
        }
    }, [user.id, navigate, location.pathname]);

    return (
        <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: '#F8FAFC' }}>
            <link rel="stylesheet" href={`${BASE_URL}/assets/css/frontend.css`} />
            <Header setBgColor={setBgColor} />
            <main className="flex-grow-1">
                {children}
            </main>
            <Footer />
            <CookieConcentPopup />
        </div>
    );
}

export default FrontendLayout;
